import { render, staticRenderFns } from "./BundlingPrimaryProduct.vue?vue&type=template&id=53fb46ea&scoped=true&"
import script from "./BundlingPrimaryProduct.vue?vue&type=script&lang=js&"
export * from "./BundlingPrimaryProduct.vue?vue&type=script&lang=js&"
import style0 from "./BundlingPrimaryProduct.vue?vue&type=style&index=0&id=53fb46ea&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53fb46ea",
  null
  
)

export default component.exports